/**
 * Do not edit directly
 */

export default "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJhIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTTEsMTZWMUgxNVYxMi43OUgzLjgybC0yLjgyLDMuMjFaTTIuMDQsMi4xMVYxMy4ybDEuMjYtMS40NkgxMy45NlYyLjExSDIuMDRaIi8+PC9zdmc+";